var map = {
	"./logo.png": "cf05",
	"./rect.png": "b862",
	"./アンロスト・ワールド.png": "a7e0",
	"./ウルティマ・トゥーレ.png": "06aa",
	"./エルピス.png": "2bdc",
	"./オルコ・パチャ.png": "fcf7",
	"./ガレマルド.png": "772d",
	"./コザマル・カ.png": "82c3",
	"./サベネア島.png": "eaa3",
	"./シャーローニ荒野.png": "e373",
	"./ヘリテージファウンド.png": "35d9",
	"./ヤクテル樹海.png": "4783",
	"./ラヴィリンソス.png": "8b8b",
	"./嘆きの海.png": "fbbf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";